import TournamentLinesPage from "@/pages/tournament/lines/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/lines")({
    component: TournamentLinesPage,
});
